/* eslint-disable radix */
import React from "react";
import { useOffer } from "../../hooks/offer";
import CustomLink from "../CustomLink";

import {
  WrapperContainer,
  BlocoInterno,
  HeaderContainer,
  PartnerImg,
  ImgLogo,
  PartnerContainer
} from "./styles";

import { useSelector } from "react-redux";

const selector = state => ({
  component: state.component
});

export default function Header() {
  const { component } = useSelector(selector);
  const { veloeLogo, partnerLogo, isGeneric } = component;
  const { currentOffer } = useOffer();

  return (
    <WrapperContainer>
      <BlocoInterno>
        <HeaderContainer>
          <CustomLink
            to="/parcerias"
            tagLabel="logo-veloe"
            parentComponent="menu"
          >
            <div className="logo">
              <ImgLogo>
                <img 
                  src={"https://" + veloeLogo}
                  alt={veloeLogo}
                />
              </ImgLogo>
            </div>
          </CustomLink>
          {currentOffer && currentOffer.logo ? (
            <PartnerContainer>
              <PartnerImg src={currentOffer.logo} alt="Parceiro" />
            </PartnerContainer>
          ) : (!isGeneric && partnerLogo) ? (
            <PartnerContainer>
              <PartnerImg src={partnerLogo} alt="Parceiro" />
            </PartnerContainer>

          ) : null}
        </HeaderContainer>
      </BlocoInterno>
    </WrapperContainer>
  );
}

// Header.propTypes = {};

// export default Header;
